import t from"antd/lib/list";export*from"antd/lib/list";var r=t,e=r.Item,i=r.Item.Meta;export{r as List,e as ListItem,i as ListItemMeta};
